export const authConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  LOGOUT: 'USERS_LOGOUT',

  USER_INFO_REQUEST: 'USERS_GET_USER_INFO_REQUEST',
  USER_INFO_SUCCESS: 'USERS_GET_USER_INFO_SUCCESS',
  USER_INFO_FAILURE: 'USERS_GET_USER_INFO_FAILURE',

  PUSH_INFO_REQUEST: 'PUSH_INFO_REQUEST',
  PUSH_INFO_SUCCESS: 'PUSH_INFO_SUCCESS',
  PUSH_INFO_FAILURE: 'PUSH_INFO_FAILURE',

  KMC_REQUEST: 'KMC_CERT_REQUEST',
  KMC_SUCCESS: 'KMC_CERT_SUCCESS',
  KMC_FAILURE: 'KMC_CERT_FAILURE',

  IPIN_REQUEST: 'IPIN_CERT_REQUEST',
  IPIN_SUCCESS: 'IPIN_CERT_SUCCESS',
  IPIN_FAILURE: 'IPIN_CERT_FAILURE',

  FIND_REQUEST: 'FIND_REQUEST',
  FIND_SUCCESS: 'FIND_SUCCESS',
  FIND_FAILURE: 'FIND_FAILURE',

  RESET_FIND_INFO: 'RESET_FIND_INFO',

  /**간편로그인 */
  PASS_LOGIN_REQUEST: 'PASS_LOGIN_REQUEST',
  PASS_LOGIN_SUCCESS: 'PASS_LOGIN_SUCCESS',
  PASS_LOGIN_FAILURE: 'PASS_LOGIN_FAILURE',

  PIN_RESET_REQUEST: 'PIN_RESET_REQUEST',
  PIN_RESET_SUCCESS: 'PIN_RESET_SUCCESS',
  PIN_RESET_FAILURE: 'PIN_RESET_FAILURE',

  /**SNS 로그인 */
  SNS_LOGIN_REQUEST: 'SNS_LOGIN_REQUEST',
  SNS_LOGIN_SUCCESS: 'SNS_LOGIN_SUCCESS',
  SNS_LOGIN_FAILURE: 'SNS_LOGIN_FAILURE',

  /**공동 인증서 로그인 */
  CRTFCT_LOGIN_REQUEST: 'CRTFCT_LOGIN_REQUEST',
  CRTFCT_LOGIN_SUCCESS: 'CRTFCT_LOGIN_SUCCESS',
  CRTFCT_LOGIN_FAILURE: 'CRTFCT_LOGIN_FAILURE',

  /**디지털원패스 */
  DIGTOP_REQUEST: 'DIGTOP_REQUEST',
  DIGTOP_SUCCESS: 'DIGTOP_SUCCESS',
  DIGTOP_FAILURE: 'DIGTOP_FAILURE',

  /**qr 생성 */
  QRIMG_REQUEST: 'QRIMG_REQUEST',
  QRIMG_SUCCESS: 'QRIMG_SUCCESS',
  QRIMG_FAILURE: 'QRIMG_FAILURE',

  /**기기고유번호 확인 */
  MOBILE_UUID_REQUEST: 'MOBILE_UUID_REQUEST',
  MOBILE_UUID_SUCCESS: 'MOBILE_UUID_SUCCESS',
  MOBILE_UUID_FAILURE: 'MOBILE_UUID_FAILURE',

  /** deviceId 가져오기 */
  GET_DEVICE_ID_REQUEST: 'GET_DEVICE_ID_REQUEST',
  GET_DEVICE_ID_SUCCESS: 'GET_DEVICE_ID_SUCCESS',
  GET_DEVICE_ID_FAILURE: 'GET_DEVICE_ID_FAILURE',

  /** 패스워드인증 **/
  SHOW_PWD_POPUP: 'SHOW_PWD_POPUP',
  PWD_REQUEST: 'PWD_REQUEST',
  PWD_SUCCESS: 'PWD_SUCCESS',
  PWD_FAILURE: 'PWD_FAILURE',
}
